<template>
    <div class="table-bg-grey mb-3">
        <PayslipDetailsModal :show_payslip_details.sync="modals.show_payslip_details" :payslip_details="selectedRow" />
        <div class="table-listings">
            <b-table-simple responsive borderless>
                <b-thead>
                    <b-tr>
                        <b-th>Payslip Period</b-th>
                        <b-th>Total Commission</b-th>
                        <b-th>Total Balance Comm. (RM)</b-th>
                        <b-th>Status</b-th>
                        <b-th>Paid Date</b-th>
                        <b-th></b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(item, index) in tableData" :key="index">
                        <b-td>
                            <p class="text-primary font-weight-500 cursor-pointer" @click="payslipPDF(item)">
                                {{ item.payslip_period }}
                            </p>
                        </b-td>
                        <b-td>{{ item.total_net_pay | moneyFormatter }}</b-td>
                        <b-td>{{ item.total_balance_comm | moneyFormatter }}</b-td>
                        <b-td>
                            <p v-if="item.status === 'Paid'" class="text-success">{{ item.status }}</p>
                            <p v-else class="text-danger">{{ item.status }}</p>
                        </b-td>
                        <b-td>{{ item.paid_date }}</b-td>
                        <b-td>
                            <svg xmlns="http://www.w3.org/2000/svg" class="text-primary cursor-pointer" width="16" height="16" viewBox="0 0 512 512">
                                <path fill="currentColor" d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v242.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-32c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/>
                            </svg>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>
    </div>
</template>
<script>
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import PayslipDetailsModal from '@/views/Commission/Payout/PayoutSummaries/Modals/PayslipDetailsModal'

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        PayslipDetailsModal,
    },
    data() {
        return {
            isTableLoading: false,
            tableData: 
            [
                {
                    payslip_period: 'Nov 2023',
                    total_net_pay: 3600,
                    total_balance_comm: 1000,
                    status: 'Paid',
                    paid_date: '22 Nov, 2023'
                },
                {
                    payslip_period: 'Dec 2023',
                    total_net_pay: 2400,
                    total_balance_comm: 500,
                    status: 'Partial',
                    paid_date: '23 Dec, 2023'
                }
            ],
            modals: {
                show_payslip_details: false
            },
            selectedRow: {}
        }
    },
    methods: {
        payslipPDF(payslip) {
            this.modals.show_payslip_details = true
            this.selectedRow = payslip
        }
    }
}
</script>